import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class F1065SchK1Service {

  constructor(private http: HttpClient) {}

  /**
   * Load main Schedule K-1 form data
   * action_code: kdwdr5
   */
  loadFormData(
    baseUrl: string,
    rowData: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'kdwdr5',
      activity_key: '6170',
      is_locked: '',
      jcd_key: rowData.JCD_KEY,
      jcd_ta_key: '5321',
      me_by_entity: '',
      scenario: rowData.SCENARIO_KEY,
      screen_type: 'grid',
      tax_year: rowData.TAX_YEAR,
      combination_key: rowData.COMBINATION_KEY,
      schedule_name: 'K1',
      ...globalService?.globalParams,
      ...filterParams
    };

    return this.http.get<any>(url, {
      params,
      withCredentials: true
    });
  }

  /**
   * Load Line 14 and Line 20 data
   * action_code: aj0tnt
   */
  loadLine20Data(
    baseUrl: string,
    rowData: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'aj0tnt',
      activity_key: '31334',
      is_locked: '',
      jcd_key: rowData.JCD_KEY,
      jcd_ta_key: '5321',
      me_by_entity: '',
      scenario: rowData.SCENARIO_KEY,
      screen_type: 'grid',
      tax_year: rowData.TAX_YEAR,
      combination_key: rowData.COMBINATION_KEY,
      schedule_name: 'K1',
      ...globalService?.globalParams,
      ...filterParams
    };

    return this.http.get<any>(url, {
      params,
      withCredentials: true
    });
  }

  /**
   * Save Schedule K-1 form data
   * Payload must match AngularJS structure EXACTLY
   */
  saveScheduleK1Form(
    baseUrl: string,
    rowData: any,
    saveJson: any[],
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=tkgaam`;

    const jsonSettings = JSON.stringify({
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO_KEY || rowData.SCENARIO,
      jcd_key: rowData.JCD_KEY,
      combination_key: rowData.COMBINATION_KEY
    });

    const jsonObj = JSON.stringify(saveJson);

    // Build checkLockedbj - same as NGJS
    const checkLockedbj = JSON.stringify([{
      leid: rowData.LEID,
      combination_key: rowData.COMBINATION_KEY,
      scenario_key: rowData.SCENARIO_KEY || rowData.SCENARIO
    }]);

    // Build params object - EXACT order as NGJS payload:
    // jsonSettings, jsonObj, tax_year, screen_key, scenario, jcd_key, jcd_ta_key,
    // activity_key, screen_type, is_locked, issue_id, issue_short_desc,
    // issue_id_for_tx_save, checkLockedbj, scenarioCode, is_issue_key_enabled,
    // parent_me_string, process_name
    const params: { [key: string]: any } = {};
    
    // 1. jsonSettings
    params['jsonSettings'] = jsonSettings;
    
    // 2. jsonObj
    params['jsonObj'] = jsonObj;
    
    // 3. Fixed params from NGJS GlobalService.globalParams
    params['tax_year'] = rowData.TAX_YEAR;
    params['screen_key'] = '10613';
    params['scenario'] = rowData.SCENARIO_KEY || rowData.SCENARIO;
    params['jcd_key'] = rowData.JCD_KEY;
    params['jcd_ta_key'] = '5321';
    params['activity_key'] = '6170';
    params['screen_type'] = 'grid';
    params['is_locked'] = 'N';
    params['issue_id'] = rowData.ISSUE_ID || '';
    params['issue_short_desc'] = rowData.ISSUE_DESC || '';
    params['issue_id_for_tx_save'] = '';
    params['checkLockedbj'] = checkLockedbj;
    
    // 4. filterParams (contains scenarioCode, is_issue_key_enabled, parent_me_string)
    if (filterParams) {
      // Add scenarioCode if present
      if (filterParams.scenarioCode !== undefined) {
        params['scenarioCode'] = filterParams.scenarioCode;
      } else {
        params['scenarioCode'] = 'RAF'; // Default value from NGJS
      }
      
      // Add is_issue_key_enabled if present
      if (filterParams.is_issue_key_enabled !== undefined) {
        params['is_issue_key_enabled'] = filterParams.is_issue_key_enabled;
      } else {
        params['is_issue_key_enabled'] = 'N'; // Default value from NGJS
      }
      
      // Add parent_me_string if present
      if (filterParams.parent_me_string) {
        params['parent_me_string'] = filterParams.parent_me_string;
      }
    } else {
      // Defaults if filterParams is missing
      params['scenarioCode'] = 'RAF';
      params['is_issue_key_enabled'] = 'N';
    }
    
    // 5. process_name at the end
    params['process_name'] = 'FORM_SAVE_1065_SCHK1';

    // Build URL-encoded body
    const body = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    return this.http.post<any>(url, body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true
    });
  }
}

